// src/i18n.ts
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// ✅ Import JSON directly (simple + reliable)
import en from "./locales/en/translation.json";
// import ta from "./locales/ta/translation.json"; // ✅ COMMENTED: Tamil disabled for now

type Lang = "en"; // ✅ only English for now

const readSavedLang = (): Lang => {
  // ✅ English only now (keep logic simple)
  return "en";

  /*
  // ✅ COMMENTED: Tamil/English switch disabled for now
  try {
    const saved = localStorage.getItem("tkm_lang");
    return saved === "ta" || saved === "en" ? saved : "en";
  } catch {
    return "en";
  }
  */
};

const initialLang = readSavedLang();

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    // ta: { translation: ta }, // ✅ COMMENTED: Tamil disabled for now
  },
  lng: initialLang,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  returnEmptyString: false,
  returnNull: false,
});

export const setAppLanguage = async (lng: Lang) => {
  // ✅ English only (no-op) — kept for future use
  await i18n.changeLanguage("en");
  document.documentElement.lang = "en";

  /*
  // ✅ COMMENTED: Tamil/English switch disabled for now
  try {
    localStorage.setItem("tkm_lang", lng);
  } catch {
    // ignore
  }
  await i18n.changeLanguage(lng);
  document.documentElement.lang = lng;
  */
};

export default i18n;
